var map = {
	"./7-eleven_logo.svg.png": 65176,
	"./American-Express-logo.png": 40916,
	"./Mastercard-logo.png": 20175,
	"./Maybank-logo.png": 79036,
	"./VISA-logo.png": 82590,
	"./download (2).png": 45276,
	"./download.png": 53163,
	"./fpx-logo-vector-01.png": 13261,
	"./z-QR.png": 45713,
	"Common/Components/AppFooter/Assets/Icons/Png/7-eleven_logo.svg.png": 65176,
	"Common/Components/AppFooter/Assets/Icons/Png/American-Express-logo.png": 40916,
	"Common/Components/AppFooter/Assets/Icons/Png/Mastercard-logo.png": 20175,
	"Common/Components/AppFooter/Assets/Icons/Png/Maybank-logo.png": 79036,
	"Common/Components/AppFooter/Assets/Icons/Png/VISA-logo.png": 82590,
	"Common/Components/AppFooter/Assets/Icons/Png/download (2).png": 45276,
	"Common/Components/AppFooter/Assets/Icons/Png/download.png": 53163,
	"Common/Components/AppFooter/Assets/Icons/Png/fpx-logo-vector-01.png": 13261,
	"Common/Components/AppFooter/Assets/Icons/Png/z-QR.png": 45713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50479;